import { Button, Form, Input, Toast } from "antd-mobile";
import { LockOutline, UserOutline } from "antd-mobile-icons";
import { useI18n } from "i18n/useI18n";
import { UserLoginDataType } from "pages/webapp/login";
import { useEffect } from "react";
import UserApi from "services/apis/sys/user-api";
import regUtil from "utils/regUtil";

export type LoginDataType = {
  isConsole: boolean;
  isLogin: boolean;
  toggleIsLogin: any;
  regSuccess: boolean;
  setRegSuccess: any;
  onFinish: (user: UserLoginDataType) => void;
};

export default function LoginForm(props: LoginDataType) {
  const { t } = useI18n();
  const usernameTip = t("setting.index.028478-0") + t("setting.index.028478-1");
  const passwordTip = t("setting.index.028478-2") + t("setting.index.028478-1");
  const [form] = Form.useForm();
  useEffect(() => {
    if (props.regSuccess) {
      form.resetFields();
    }
  }, [props.regSuccess]);
  return (
    <Form
      mode="card"
      form={form}
      onFinish={() => {
        props.onFinish({
          username: form.getFieldValue("username"),
          password: form.getFieldValue("password"),
        });
      }}
      footer={
        <div style={{ marginBottom: -25, padding: 0 }}>
          <Button
            block
            type="submit"
            size="small"
            style={{
              padding: "8px 10px",
              background: "#f77",
              color: "#fff",
            }}
          >
            {props.isLogin
              ? t("loginform.index.180775-0")
              : t("loginform.index.180775-1")}
          </Button>
          <Button
            block
            size="small"
            style={{
              padding: "8px 10px",
              background: "#a99",
              color: "#fff",
              marginTop: 10,
            }}
            onClick={() => {
              props.toggleIsLogin(!props.isLogin);
              const username = form.getFieldValue("username");
              const password = form.getFieldValue("password");
              form.resetFields();
              form.setFieldValue("username", username);
              form.setFieldValue("password", password);
            }}
          >
            {props.isLogin
              ? t("loginform.index.180775-2")
              : t("loginform.index.180775-3")}
          </Button>
          <div style={{ marginTop: 20, marginBottom: 0 }}>
            <p
              style={{ fontSize: 14, color: "#999" }}
              onClick={() => {
                Toast.show(t("loginform.index.180775-4"));
              }}
            >
              {t("loginform.index.180775-5")}
            </p>
          </div>
        </div>
      }
    >
      <Form.Header>
        <p style={{ margin: 0, marginBottom: 15, color: "#333", fontSize: 16 }}>
          {props.isLogin
            ? t("loginform.index.180775-6")
            : t("loginform.index.180775-7")}
        </p>
      </Form.Header>
      <Form.Item
        name="username"
        rules={[
          {
            required: true,
            message: t("loginform.index.180775-8"),
          },
          {
            pattern: regUtil.usernameRegexp,
            message: usernameTip,
          },
          {
            validateTrigger: "onBlur",
            validator(rule, value, callback) {
              const fetch = async (username: string) => {
                const result = await UserApi.checkUsername(username);
                if (result.code === 0 && result.successful && result.result) {
                  return callback(t("loginform.index.180775-9"));
                }
                return callback();
              };
              if (!props.isLogin) {
                fetch(form.getFieldValue("username"));
              } else {
                return callback();
              }
            },
          },
        ]}
      >
        <Input
          // bordered={false}
          // prefix={<UserOutline fontSize={20} style={{ marginRight: 10 }} />}
          placeholder={t("loginform.index.180775-8")}
          style={{
            color: "#666",
          }}
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          { required: true, message: t("loginform.index.180775-10") },
          {
            pattern: regUtil.passwordRegexp,
            message: passwordTip,
          },
        ]}
      >
        {/* <Input.Password */}
        <Input
          // bordered={false}
          // prefix={<LockOutline fontSize={20} style={{ marginRight: 10 }} />}
          placeholder={t("loginform.index.180775-10")}
          style={{
            color: "#666",
          }}
        />
      </Form.Item>
      {!props.isLogin && (
        <Form.Item
          name="password2"
          rules={[
            { required: true, message: t("loginform.index.180775-11") },
            {
              pattern: regUtil.passwordRegexp,
              message: passwordTip,
            },
            {
              validator(rule, value, callback) {
                const password = form.getFieldValue("password");
                if (value && password !== value) {
                  return callback(t("loginform.index.180775-12"));
                }
                return callback();
              },
            },
          ]}
        >
          {/* <Input.Password */}
          <Input
            // bordered={false}
            // prefix={<LockOutline fontSize={20} style={{ marginRight: 10 }} />}
            placeholder={t("loginform.index.180775-11")}
            style={{
              color: "#666",
            }}
          />
        </Form.Item>
      )}

      {false && (
        <>
          <Form.Item
            style={{ border: 0 }}
            name="phone"
            extra={<a>{t("loginform.index.180775-13")}</a>}
            rules={[
              { required: true, message: t("loginform.index.180775-14") },
              {
                pattern:
                  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                message: t("loginform.index.180775-15"),
              },
            ]}
          >
            <Input placeholder={t("loginform.index.180775-14")} />
          </Form.Item>
          <Form.Item
            style={{ fontSize: 10 }}
            name="kapcha"
            rules={[
              { required: true, message: t("loginform.index.180775-16") },
            ]}
          >
            <Input
              placeholder={t("loginform.index.180775-16")}
              style={{ fontSize: 10 }}
            />
          </Form.Item>
        </>
      )}
    </Form>
  );
}
